module.exports = fox._r("images/valid-ico.png", __webpack_public_path__ + "_/_/_/common/frame/images/valid-ico.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/valid-ico.png
// module id = 14
// module chunks = 2